<template>
    <span
        class="recruit-type-toggle"
        v-if="show"
        @click="onClickCallback()"
    >
        <img
            :src="`${imgBaseUrl}/bishop.png`"
            class="coin-img img-bishop"
            v-if="enabled"
        />
        <img
            :src="coinBackImg"
            class="coin-img img-facedown-coin"
            v-if="!enabled"
        />
        <span class="recruit-toggle-icon-wrapper">
            <fa-icon class="recruit-toggle-icon" icon="sync-alt" />
        </span>
    </span>
</template>

<script>
import coinBackImg from '../../assets/coin_back.png';
import { API_BASE_URL } from '@/helpers/env';

export default {
    name: 'BishopToggle',
    props: ['show', 'onClickCallback', 'enabled'],
    data() {
        return {
            coinBackImg,
        };
    },
    computed: {
        apiUrl() {
            return API_BASE_URL;
        },
        imgBaseUrl() {
            return `${this.apiUrl}/assets`;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .recruit-type-toggle {
        cursor: pointer;
        position: absolute;

        .recruit-toggle-icon-wrapper {
            background: white;
            border: 1px solid $bishop;
            border-radius: 50%;
            position: absolute;
            z-index: 1;

            .recruit-toggle-icon {
                color: $bishop;
            }
        }
    }

    .mobile-player-mat {

        .recruit-type-toggle {
            height: 25%;
            width: 25%;
            left: 2.5%;
            top: -24%;

            .coin-img {
                height: 100%;
                width: auto;
            }

            .recruit-toggle-icon-wrapper {
                display: flex;
                justify-content: center;
                right: -110%;
                top: -16%;
                max-height: 47.7%;

                .recruit-toggle-icon {
                    align-self: center;
                    max-height: 68%;
                    max-width: 68%;
                }
            }
        }
    }

    .player-mat {

        .recruit-type-toggle {
            height: 100%;
            left: -100%;
            top: -75%;
            width: 100%;

            .coin-img {
                height: 150%;
                width: auto;
            }

            .recruit-toggle-icon-wrapper {
                max-height: 87.3%;
                right: -10%;
                top: -62%;

                .recruit-toggle-icon {
                    max-height: 68%;
                    max-width: 68%;
                }
            }
        }
    }

</style>
